
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue } from "vue-property-decorator";
import BgNavPageItem from "../bg-nav-page-item/index.vue";
@Component({})
export default class BgNavPage extends Vue {
  @Prop({ required: false, default: "left" }) navPosition?: "left" | "right";
  @Prop({ required: false, default: "100%" }) width?: string;
  @Prop({ required: false, default: "100%" }) height?: string;
  @Prop({ required: false, default: "200px" }) navWidth?: string;
  items: any = [];
  genItemsTimer = 0;
  current = "";
  scrollingIntoView = false;
  // currentItem: any = null;
  mounted(): void {
    this.init();
    this.handleScroll();
  }
  updated(): void {
    this.init();
  }
  handleScroll() {
    const content = this.$refs.content as HTMLElement;
    let handleTimer = 0;
    content.addEventListener("scroll", () => {
      if (this.scrollingIntoView) {
        return;
      }
      clearTimeout(handleTimer);
      handleTimer = window.setTimeout(() => {
        const contentRect = content.getBoundingClientRect();
        for (let item of this.items) {
          const itemRect = (
            item?.componentInstance?.$el as HTMLElement
          ).getBoundingClientRect();
          if (itemRect.top >= contentRect.top) {
            this.setCurrentItem(item);
            break;
          }
        }
      }, 100);
    });
  }
  init(): void {
    clearTimeout(this.genItemsTimer);
    setTimeout(() => {
      this.getItems();
      const shouldInitCurrent =
        !this.current ||
        (this.current &&
          !this.items.some(
            (ele: any) => ele.componentOptions?.propsData?.name === this.current
          ));
      if (shouldInitCurrent && this.items.length) {
        this.current =
          this.items[0].componentOptions &&
          this.items[0].componentOptions.propsData.name;
        // this.currentItem = this.items[0];
      }
    });
  }
  getItems(): void {
    const items =
      this.$slots.default?.filter(
        // (com) => com?.componentOptions?.Ctor?.name === "BgNavPageItem"
        (com) => com?.componentInstance instanceof BgNavPageItem
      ) || [];
    this.items = items;
  }
  changeCurrent(item: any): void {
    const currentName =
      item.componentOptions && item.componentOptions.propsData.name;
    if (currentName !== this.current) {
      this.current = currentName;
      // this.currentItem = item;
      const elem = item?.componentInstance?.$el as HTMLElement;
      this.scrollingIntoView = true;
      elem.scrollIntoView();
      const scrollTime = 300;
      setTimeout(() => {
        this.scrollingIntoView = false;
      }, scrollTime);
    }
  }
  setCurrentItem(item: any) {
    const currentName =
      item.componentOptions && item.componentOptions.propsData.name;
    this.current = currentName;
    // this.currentItem = item;
  }
}
